import { render, staticRenderFns } from "./SalesPage.vue?vue&type=template&id=5ac3f20e&scoped=true&"
import script from "./SalesPage.vue?vue&type=script&lang=js&"
export * from "./SalesPage.vue?vue&type=script&lang=js&"
import style0 from "./SalesPage.vue?vue&type=style&index=0&id=5ac3f20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac3f20e",
  null
  
)

export default component.exports